import { getCLS, getFID, getLCP } from 'web-vitals';
import { createApiReporter, getDeviceInfo } from 'web-vitals-reporter';
import { routeList } from '../boot/addMissingConfig';
let globalPageType = undefined;
export function setPageType(type) {
    if (!globalPageType) {
        globalPageType = type;
    }
}
export function webVitals({ shopId, apiUrl }) {
    var _a;
    // Init report callback with information about the browser.
    const deviceInfo = getDeviceInfo();
    Object.keys(routeList).forEach(route => {
        var _a;
        if ((_a = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.url) === null || _a === void 0 ? void 0 : _a.includes(routeList[route])) {
            globalPageType = route;
        }
    });
    const sendToAnalytics = createApiReporter(`${apiUrl}/api/v1/webvitals`, {
        initial: {
            shopId: shopId,
            appName: 'flight',
            pageType: globalPageType,
            userAgent: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.userAgent,
            memory: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.memory,
            cpus: deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.cpus,
            connection: (_a = deviceInfo === null || deviceInfo === void 0 ? void 0 : deviceInfo.connection) === null || _a === void 0 ? void 0 : _a.effectiveType
        },
        beforeSend: () => {
            return { pageType: globalPageType };
        }
    });
    // Setup web-vitals
    getLCP(sendToAnalytics);
    getFID(sendToAnalytics);
    getCLS(sendToAnalytics);
}
//# sourceMappingURL=webVitals.js.map